import { useState } from 'react';
import Modal from '../../Modal';
import {
  Container,
  Header,
  Photo,
  Title,
  Image,
  LinksContainer,
  GreyLine,
  Info1,
  Body,
  Info2,
  BodyInput,
  Footer,
} from './style';
import Profile from '../../../../assets/icons/Profile';
import { useDispatch, useSelector } from 'react-redux';

import Button from '../../Button';
import Input from '../../Input';
import { signOut } from '../../../../state/auth/actions';
import ProfilePictureModal2 from '../ProfilePictureModal2';
import { handleUpdateUser } from '../../../../state/users/actions';
import { toastAlert } from '../../../Toastify/index';
import { ProtectedComponent } from '../../Protected/index';

const useError = () => {
  const [error, setError] = useState({
    email: { msg: '', isError: false },
    username: { msg: '', isError: false },
    enterpriseName: { msg: '', isError: false },
  });

  const usernameErrorOn = () => {
    setError((prevError) => ({
      ...prevError,
      username: {
        msg: 'Por favor, preencha o seu nome completo',
        isError: true,
      },
    }));
  };

  const usernameErrorOff = () => {
    setError((prevError) => ({
      ...prevError,
      username: {
        msg: '',
        isError: false,
      },
    }));
  };

  const emailErrorOn = () => {
    setError((prevError) => ({
      ...prevError,
      email: {
        msg: 'Necessário preencher o email',
        isError: true,
      },
    }));
  };

  const emailErrorOff = () => {
    setError((prevError) => ({
      ...prevError,
      email: {
        msg: '',
        isError: false,
      },
    }));
  };

  const enterpriseErrorOn = () => {
    setError((prevError) => ({
      ...prevError,
      enterpriseName: {
        msg: 'Necessário preencher o nome da Empresa',
        isError: true,
      },
    }));
  };

  const enterpriseErrorOff = () => {
    setError((prevError) => ({
      ...prevError,
      enterpriseName: {
        msg: '',
        isError: false,
      },
    }));
  };

  return {
    error,
    username: { on: usernameErrorOn, off: usernameErrorOff },
    email: { on: emailErrorOn, off: emailErrorOff },
    enterprise: { on: enterpriseErrorOn, off: enterpriseErrorOff },
  };
};

const UserModal = ({
  isOpen,
  onClose,
  selector,
  className,
  modalChange,
  usePicture,
  handleDeletePicture,
}) => {
  const [picture, setPicture] = usePicture;

  const user = useSelector((state) => state.auth.user);

  const [loading, setLoading] = useState(false);

  const [userName, setUserName] = useState(user.username);
  const [userEmail, setUserEmail] = useState(user.email);
  const [userEmpresa, setUserEmpresa] = useState(user.enterpriseName);

  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const { error, username, email, enterprise } = useError();

  const handleSave = async () => {
    let ErrorUsername = false;
    let ErrorEmail = false;
    let ErrorEnterprise = false;

    if (userName === '') {
      username.on();
      ErrorUsername = true;
    } else {
      username.off();
    }

    if (userEmail === '') {
      email.on();
      ErrorEmail = true;
    } else {
      email.off();
    }

    if (userEmpresa === '') {
      enterprise.on();
      ErrorEnterprise = true;
    } else {
      enterprise.off();
    }

    return { ErrorEmail, ErrorUsername, ErrorEnterprise };
  };

  return (
    <Modal
      id="user_modal"
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
      modalChange={modalChange}
    >
      <Container>
        <Header>
          <Profile />
          <Title>Editar Perfil</Title>
        </Header>
        <Photo>
          <Image src={picture} alt="Avatar" />

          <LinksContainer>
            <Button
              noBackground
              colorText="#32C788"
              content={'Enviar Foto'}
              padding={' 0rem'}
              margin={' 0.7rem 0rem 0rem 0rem'}
              onClick={() => setOpen(true)}
            />
            <Button
              noBackground
              content={'Remover'}
              padding={' 0rem 0rem 0rem 0rem'}
              margin={' 0.4rem 0rem 0rem 0rem'}
              onClick={() => handleDeletePicture(user._id)}
            />
          </LinksContainer>
        </Photo>
        <GreyLine />
        <Body>
          <Info1>Informações do Perfil</Info1>
          <Info2>Mantenha suas informações de perfil atualizadas.</Info2>
          <BodyInput>
            <Input
              style={{ padding: '0 0 1rem 0' }}
              value={userName}
              setValue={(e) => {
                setUserName(e);
              }}
              label="Nome Completo"
              placeholder={userName}
              error={error.username.isError}
              errorMsg={error.username.msg}
            />
            <Input
              style={{ padding: '0 0 1rem 0' }}
              value={userEmail}
              setValue={(e) => {
                setUserEmail(e);
              }}
              label="Endereço de E-mail"
              placeholder={userEmail}
              error={error.email.isError}
              errorMsg={error.email.msg}
            />
            <ProtectedComponent allowed={['admin']} rank={user?.rank}>
              <Input
                style={{ padding: '0 0 1rem 0' }}
                value={userEmpresa}
                setValue={(e) => {
                  setUserEmpresa(e);
                }}
                label="Empresa"
                placeholder={userEmpresa}
                error={error.enterpriseName.isError}
                errorMsg={error.enterpriseName.msg}
              />
            </ProtectedComponent>
          </BodyInput>
          <Button
            greenBase
            content={'Alterar Senha'}
            width={'7rem'}
            height={'2.27rem'}
            onClick={() => {
              onClose();
              modalChange();
            }}
          />
        </Body>
        <Footer>
          <Button
            outline
            content={'Cancelar'}
            padding={'0rem'}
            width={'7.95rem'}
            height={'2.27rem'}
            margin={'0rem 1rem 0rem 0rem'}
            onClick={() => onClose()}
          />
          <Button
            content={'Salvar'}
            padding={'0rem'}
            width={'7.95rem'}
            height={'2.27rem'}
            onClick={() => {
              handleSave().then((res) => {
                const { ErrorEmail, ErrorEnterprise, ErrorUsername } = res;

                const isValid =
                  !ErrorEmail && !ErrorEnterprise && !ErrorUsername;

                if (isValid) {
                  onClose();
                  dispatch(
                    handleUpdateUser({
                      username: userName,
                      email: userEmail,
                      enterpriseName: userEmpresa,
                    })
                  )
                    .then((res) => {
                      toastAlert({
                        msg: 'Dados de usuário atualizadas com sucesso! Entre com sua conta para VALIDAR as infomações.',
                      });
                      dispatch(signOut());
                    })
                    .catch((err) =>
                      toastAlert({
                        msg: `Ocorreu um ERRO ao atualizar os dados de usuário: ${err}`,
                        isError: true,
                      })
                    );
                }
              });
            }}
          />
        </Footer>
      </Container>

      <ProfilePictureModal2
        isOpen={open}
        onClose={() => setOpen(false)}
        change={(e) => setOpen(e)}
        user={user}
        setPicture={setPicture}
        useLoading={[loading, setLoading]}
      />
    </Modal>
  );
};

export default UserModal;
